<template>
  <div class="htmltext">
      <span>
          {{message}}
      </span>
  </div>
</template>

<script>
export default {
    props:['message']
}
</script>

<style scoped>
    .htmltext{
        font-size: 14px;
        color: #BECCE7;
        line-height: 34px;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/HtmlTextSmall.vue